import {
	ALL_LANGUAGES_LOADING,
	ALL_LANGUAGES_GET,
	ALL_LANGUAGES_ERROR
} from '../actions/types';

const initialState = {
	all_languages_loading: false,
	all_languages: [],
	languages_errors: {}
}

export default function languagesReducer(state = initialState, action) {
	switch (action.type) {
		case ALL_LANGUAGES_LOADING:
			return {
				...state,
				all_languages_loading: action.payload
			}
		case ALL_LANGUAGES_GET:
			delete state.languages_errors.all_languages
			return {
				...state,
				all_languages: action.payload
			}
		case ALL_LANGUAGES_ERROR:
			return {
				...state,
				languages_errors: {
					...state.languages_errors, 
					[`${action.payload.type}`]: { msg: action.payload.msg }
				}
			}
		default:
			return state;
	}
}
